import {FaExternalLinkAlt} from "react-icons/fa";
import ProjectUtils from "../../../../utils/project-utils.js";
import React, {useState} from "react";
import ModalImage from "../../../../components/modal/modal-image.jsx";
import ModalAttaches from "../../../../components/modal/modal-attaches.jsx";
import EncounterIndividualContent from "../form/components/encounter-individual-content.jsx";
import EncounterVehicleContent from "../form/components/encounter-vehicle-content.jsx";
import EncounterJustifyContent from "../form/components/encounter-justify-content.jsx";
import EncounterActionsContent from "../form/components/encounter-actions-content.jsx";
import InfoGrid from "../../../../components/info-grid/info-grid.jsx";
import {BoKeys} from "../../bos/resources/bo-keys.js";
import {EncounterStatusEnum, isEncounterInvalidated} from "../../../../utils/enums/encounter-status-enum.js";

export function EncounterContent({ data, showImages = false }) {
    const [openImageModal, setOpenImageModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState("");
    const [modalAttach, setModalAttach] = useState({open: false, attach: null});

    const invalidated = isEncounterInvalidated(data?.status);
    const started = data?.status === EncounterStatusEnum.STARTED;
    const userName = data?.userName ?? data?.user_name;
    const userNameWar = data?.userNameWar ?? data?.user_name_war;
    const dtStart = data?.dtStart ?? data?.dt_start;
    const latitude = data?.latitude;
    const longitude = data?.longitude;

    const individuals = data?.data?.individuals ?? [];
    const vehicles = data?.data?.vehicles ?? [];
    const observation = data?.data?.observation ?? "";

    const mapsUrl = latitude && longitude ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${latitude},${longitude}`)}` : null;

    const initialInfo = [
        {
            label: "Cadastrado por",
            value: userNameWar ? `${userName} (${userNameWar})` : userName,
        },
        {
            label: "D/H de cadastro",
            value: dtStart ? ProjectUtils.formatDate(dtStart, "DD/MM/YYYY hh:mm") : "",
        },
        {
            label: "Local do preenchimento",
            children: mapsUrl ? (
                <a href={mapsUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 inner-link">
                    <span className={'break-all!'}>{latitude}, {longitude}</span>
                </a>
            ) : null
        }
    ]

    if (!data) return null;

    return (
        <>
            <div className="space-y-4 px-5! mt-[8px] print:mt-[10px]!">

                { invalidated && (
                    <article id={"status-warning"}>
                        <h3 className={"text-center min-h-[30px] border border-[#ff5353] rounded-md !text-white bg-[#ff5353]"}>
                            Abordagem inválida
                        </h3>
                    </article>
                )}

                { started && (
                    <article id={"status-warning"}>
                        <h3 className={"text-center min-h-[30px] border border-[#ffa500] rounded-md !text-white bg-[#ffa500]"}>
                            Abordagem em andamento
                        </h3>
                    </article>
                )}

                <h2 className="flex flex-row items-center justify-center w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f] print:text-[19px]!">
                    DADOS DA ABORDAGEM
                </h2>

                <InfoGrid title={''} items={initialInfo} columns={3} labelClassName={'text-[#4F4F4F] text-[13px]! print:text-[15px]!'} valueClassName={'print:text-[17px]!'}  className={'px-2!'} contentClassName={'space-y-1'}/>

                <EncounterIndividualContent individuals={individuals} vehicles={vehicles} showImages={showImages} setSelectedImage={setSelectedImage} setOpenImageModal={setOpenImageModal} setModalAttach={setModalAttach}/>

                {/*  VEICULOZINHO  */}
                <EncounterVehicleContent vehicles={vehicles} individuals={individuals} showImages={showImages} setSelectedImage={setSelectedImage} setOpenImageModal={setOpenImageModal}/>

                {/*  Justificativa  */}
                <EncounterJustifyContent observation={observation}/>

                {/* Ações decorrentes */}
                <EncounterActionsContent data={data}/>

                <ModalImage
                    open={openImageModal}
                    setOpen={setOpenImageModal}
                    imgUrl={selectedImage}
                />
                <ModalAttaches
                    open={modalAttach.open}
                    setOpen={() => setModalAttach((current) => ({...current, open: false}))}
                    file={modalAttach.attach}
                />
            </div>
        </>
    );
}
